import { AxiosInstance } from 'axios'

export type ApiOpOpts = {
    data?: any
    anotherDomainApi?: string
    headers?: Record<string, string>
    timeout?: number
    // TODO unify
    pathParams?: Record<string, string | number>
    queryParams?: Record<string, string | string[] | number | null | boolean>
    responseType?: 'json' | 'blob'
}

export type ApiOpDef = {
    method: string
    path: string
}

const paramRegex = /{.*}/

const findUnreplaced = (str: string) => str.match(paramRegex)

export class ApiClient {
    constructor(private http: AxiosInstance) {}

    do = <T>(
        op: ApiOpDef,
        opts: ApiOpOpts = {
            data: {}
        }
    ): Promise<T> => {
        let url = op.path

        if (opts?.anotherDomainApi) {
            url = url.replace('api', opts.anotherDomainApi)
        }

        if (opts.pathParams)
            Object.entries(opts.pathParams).forEach(([a, b]) => {
                url = url.replace(`{${a}}`, b.toString())
            })

        if (opts.headers) {
            Object.entries(opts.headers).forEach(([a, b]) => {
                this.http.defaults.headers.common[a] = b
            })
        }

        const unreplaced = findUnreplaced(url)

        if (unreplaced) {
            const formatted = unreplaced.map(p => `'${p}'`)
            throw new Error(
                `Url ${url} contains unreplaced params: [${formatted}]`
            )
        }

        const method = op.method.toUpperCase()

        return this.http
            .request({
                // @ts-ignore
                method,
                url,
                params: opts.queryParams || {},
                data: opts.data,
                timeout: opts.timeout,
                responseType: opts.responseType!,
                paramsSerializer: params => {
                    return Object.entries(params)
                        .map(([k, v]) => {
                            if (Array.isArray(v)) {
                                return v.map(vv => `${k}=${vv}`).join('&')
                            }
                            return `${k}=${v}`
                        })
                        .join('&')
                }
            })
            .then(r => r.data)
            .catch(e => {
                return Promise.reject(e)
            })
    }
}

// TODO make cleaner - composition and factor out, quick solution
export class HigherApiClient extends ApiClient {
    constructor(http: AxiosInstance) {
        super(http)
    }

    doForId = <T>(op: ApiOpDef, id: number) =>
        this.do<T>(op, {
            pathParams: {
                id
            }
        })
}
